import { createSlice } from '@reduxjs/toolkit';

export const user = createSlice({
    name: 'user',
    initialState: {
        name: '',
        email: '',
        birthDate: '',
        gender: '',
        locale: '',
        sex: '',
        selectedRole: null,
        roles: [],
        timezone: null,
        uuid: null,
        picture: null
    },
    reducers: {
        updateUser: (state, action) => {
            state.name = action.payload.name;
            state.email = action.payload.email;
            state.birthDate = action.payload.birth_date;
            state.gender = action.payload.gender;
            state.locale = action.payload.locale;
            state.sex = action.payload.sex;
            state.selectedRole = localStorage.getItem(
                `${action.payload.uuid}-role`
            );
            state.roles = action.payload.roles || [];
            state.timezone = action.payload.timezone;
            state.uuid = action.payload.uuid;
            state.picture = action.payload.picture;
        },
        updateRole: (state, action) => {
            const roleUuid = action.payload;
            localStorage.setItem(`${state.uuid}-role`, roleUuid);
            state.selectedRole = roleUuid;
        },
        updateRolePresence: (state, action) => {
            const { roleUuid, presenceState } = action.payload || {};
            const role = state.roles.find((item) => item.uuid === roleUuid);
            if (role) {
                role.presence_state = presenceState;
            }
        },
        resetUser: (state) => {
            state.name = '';
            state.email = '';
            state.birthDate = '';
            state.gender = '';
            state.locale = '';
            state.sex = '';
            state.selectedRole = null;
            state.roles = [];
            state.timezone = null;
            state.uuid = null;
            state.picture = null;
        }
    }
});

export const { updateUser, updateRole, updateRolePresence, resetUser } = user.actions;

export default user.reducer;
